export default "__VITE_ASSET__DhG8nb2O__"